import React, { useEffect, useState } from 'react';
import './style.scss';
import { EBundlesViewModel, Layout } from './Layouts.types';
import styled from 'styled-components';
import { StyledTwoInARowLayout } from './StyledTwoInARowLayout';
import { checkIfOlderOsVersions } from '../../Helper/utils/utils';
import { EBundlesInternalViewModel } from '../../Helper/enums';

export const StyledBundleLayout = styled.div<any>`
  &.bundles_layout {
    max-width: ${(props) => props.desktopMaxWidth};
    align-items: ${(props) =>
      props.bundlesInternalViewModel === EBundlesInternalViewModel.MAIN_SUB
        ? 'stretch'
        : 'center'};

    .bundle {
      max-width: ${(props) => props.maxWidth};
      width: 100%;

      &-top-container {
        height: ${(props) =>
          props.bundlesInternalViewModel === EBundlesInternalViewModel.MAIN_SUB
            ? '100%'
            : 'auto'};
      }

      @media (min-width: 1024px) {
        &:hover {
          z-index: 2;
          position: relative;
        }
      }
    }

    &--mobile-multiple-items {
      .bundle {
        width: calc(33.3333% - 16px);
      }

      &.pipa {
        .bundle {
          width: calc(33.3333% - 6px);
        }
      }
    }
  }
`;

const BundlesLayout = ({
  children,
  bundlesViewModel = EBundlesViewModel.LINEAR,
  gapY,
  gapX,
  maxWidthOverride,
  isPreview,
  desktopMaxWidth = '1250px',
  bundlesInternalViewModel,
}: Layout) => {
  const [addedClasses, setAddedClasses] = useState<string>('');

  useEffect(() => {
    if (checkIfOlderOsVersions()) {
      setAddedClasses('bundles_layout--ios13');
    }
  }, []);

  switch (bundlesViewModel) {
    case EBundlesViewModel.LINEAR:
      return (
        <StyledBundleLayout
          gapY={gapY}
          bundlesInternalViewModel={bundlesInternalViewModel}
          gapX={gapX}
          className={`bundles_layout bundles_layout--mobile-linear ${addedClasses}`}
          maxWidth={maxWidthOverride || '400px'}
          desktopMaxWidth={desktopMaxWidth}
        >
          {children}
        </StyledBundleLayout>
      );
    case EBundlesViewModel.TWO_IN_ONE:
      return (
        <StyledTwoInARowLayout
          className={`bundles_layout bundles_layout__two-in-row ${addedClasses}`}
          isPreview={isPreview}
        >
          {children}
        </StyledTwoInARowLayout>
      );
    case EBundlesViewModel.THREE_IN_ONE:
      return (
        <StyledBundleLayout
          gapY={gapY}
          gapX={gapX}
          className={`bundles_layout bundles_layout--mobile-multiple-items ${addedClasses} ${bundlesInternalViewModel}`}
          maxWidth={maxWidthOverride || '400px'}
          desktopMaxWidth={desktopMaxWidth}
        >
          {children}
        </StyledBundleLayout>
      );
    default:
      return null;
  }
};

export default BundlesLayout;
